import { useState } from 'react'
import { Dropdown } from 'antd'
import cn from 'classnames'
import { UserMenuItems } from './UserMenuItems'
import { ReactComponent as ThreeDots } from 'assets/svg/Dots24.svg'
import { TUsersTable } from './types'
import { USER_STATUSES } from '../../../../../../../constants'

export const UserMenu = ({
  user,
  onArchive,
  canArchiveUsers = true
}: {
  user: TUsersTable
  onArchive: (row: TUsersTable) => void
  canArchiveUsers?: boolean
}) => {
  const [visible, setVisible] = useState(false)
  return (
    <Dropdown
      onVisibleChange={() => setVisible(!visible)}
      visible={visible}
      className="menu-items"
      overlay={
        <UserMenuItems
          setVisible={setVisible}
          user={user}
          isArchived={
            user.status === USER_STATUSES.ARCHIVED || !canArchiveUsers
          }
          onArchive={onArchive}
        />
      }
      placement="bottomRight"
      trigger={['click']}
    >
      <div className={cn('dots-items')} onClick={(e) => e.stopPropagation()}>
        <ThreeDots />
      </div>
    </Dropdown>
  )
}
